import { useEffect, useState } from "react";

import { usePostSummarizeStatus } from "@/api/usePostSummarizeStatus";
import { SUMMARY_STATUS_FAILED, SUMMARY_STATUS_SUCCESS } from "@/util/constants";

interface SummarizeStatusData {
  status: string | number;
  summary?: string;
  httpStatus?: number;
  [key: string]: any;
}

interface Props {
  blob_name: string;
  enabled?: boolean;
}

export const usePollingSummarizeStatus = ({ blob_name, enabled = true }: Props) => {
  const [isPolling, setIsPolling] = useState<boolean>(enabled);
  const [currentData, setCurrentData] = useState<SummarizeStatusData | null>(null);
  const response = usePostSummarizeStatus(blob_name, isPolling);
  const shouldStopPolling = (status: string) => {
    return status === SUMMARY_STATUS_SUCCESS || status === SUMMARY_STATUS_FAILED;
  };

  const startPolling = () => {
    setIsPolling(true);
  };

  const stopPolling = () => {
    setIsPolling(false);
  };

  useEffect(() => {
    if (response) {
      const { data, httpStatus } = response;
      if (!data) return;

      setCurrentData({ ...data, httpStatus });

      if (data.status && shouldStopPolling(data.status)) {
        setIsPolling(false);
      }
    }
  }, [response]);

  useEffect(() => {
    setIsPolling(enabled);
  }, [enabled]);

  return {
    currentData: currentData,
    status: currentData?.status || "PENDING",
    summary: currentData?.summary || "",
    isPolling,
    startPolling,
    stopPolling,
  };
};
